import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * Uses DOMPurify to remove potentially dangerous content while preserving safe formatting
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    // Allow common formatting tags
    ALLOWED_TAGS: [
      'p', 'br', 'span', 'div',
      'strong', 'b', 'em', 'i', 'u',
      'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li',
      'a', 'code', 'pre',
      'blockquote',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
    ],
    // Allow safe attributes
    ALLOWED_ATTR: [
      'href', 'target', 'rel',
      'class', 'id',
    ],
    // Force links to open in new tab and add security attributes
    ALLOW_UNKNOWN_PROTOCOLS: false,
    ADD_ATTR: ['target', 'rel'],
  });
}
